import { ColumnState } from "ag-grid-community"

interface ColumnSortModel {
    colId: string
    sort: "asc" | "desc"
}

interface ColumnFilterModel {
    filterType: string,
    type: string,
    filter: string
}

export type SortModel = ColumnSortModel[]
export type FilterModel = { [key:string]:ColumnFilterModel; }

export interface StoredGridState {
    colState: ColumnState[]
}

export const storeGridState = (gridApi: any, key: string): void => {
    if (!gridApi) { return }
    if (!key) { return }
    const gridStateJson = JSON.stringify({
        colState: gridApi.getColumnState()
    })
    sessionStorage.setItem(key, gridStateJson)
}

export const retrieveGridState = (key: string): StoredGridState => {
    const gridStateJson = sessionStorage.getItem(key)
    if (!gridStateJson) { return null}
    return JSON.parse(gridStateJson)
}

// Shared utility functions for converting ag-grid filter/sort models to server-side API queries
export function getOperator(type: string) {
    const result = {
        equals: "",	                // Text, Number, Date
        notEqual: "not:",	        // Text, Number, Date
        contains: "like:",	        // Text
        notContains: "unlike:",     // Text
        startsWith: "start:",	    // Text
        endsWith: "end:",	        // Text
        lessThan: "lt:",	        // Number, Date
        lessThanOrEqual: "lte:",	// Number
        greaterThan: "gt:",         // Number, Date
        greaterThanOrEqual: "gte:", // Number
        inRange: "range:",	        // Number, Date
        in: "in:",                  // Text
        empty: "???:"               // ?choose one
    }[type]
    if (result === undefined) {
        return "???:"
    }
    return result
}

export const ArrayIndicator = "PBArray:"

export function convertQuerySortAndFilterToServerQuery(rawTextQuery, sortModel, filterModel, options) {
    if (rawTextQuery) {
        options.rawText = rawTextQuery
    }
    if (sortModel && sortModel.length) {
        options.orderBy = sortModel[0].colId
        options.sortDescending = (sortModel[0].sort === "desc")
    }
    for (const key of Object.keys(filterModel)) {
        const filter = filterModel[key]
        if (filter.filterType !== "date") {
            let filterText = String(filter.filter)
            if (filterText.includes("+")) {
                filterText = filterText.replace(/\+/g, "%2B")
            }
            options[key] = getOperator(filter.type) + filterText
            if (("" + filter.filter).startsWith(ArrayIndicator)) {
                // Workaround for ag-grid not liking "in" operator without more configuration
                options[key] = "in:" + filter.filter.substring(ArrayIndicator.length)
            }
            if (filter.type === "inRange") {
                options[key] = options[key] + "," + filter["filterTo"]
            }
        } else {
            // Date filters - send only the date part (YYYY-MM-DD) without time
            const dateValue = filter["dateFrom"].split(" ")[0] // e.g., "2025-10-15"
            
            options[key] = getOperator(filter.type) + dateValue
            if (filter.type === "inRange") {
                options[key] = options[key] + "," + filter["dateTo"].split(" ")[0]
            }
        }
    }
}
